import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Form } from 'antd';
import styled from 'styled-components';

const WrapperFormItem = styled(Form.Item)`
  margin-bottom: 0px !important;
  padding-bottom: 0px !important;
`;

const FormCheckbox = React.memo(
  ({ label = '', title, name, initialValue = false, rules = [], ...rest }) => {
    return (
      <WrapperFormItem
        label={label}
        name={name}
        initialValue={initialValue}
        rules={rules}
        valuePropName="checked"
      >
        <Checkbox {...rest}>{title}</Checkbox>
      </WrapperFormItem>
    );
  }
);

FormCheckbox.propTypes = {
  label: PropTypes.string,
  title: PropTypes.string,
  name: PropTypes.string,
  initialValue: PropTypes.bool,
  rules: PropTypes.array,
};

export default FormCheckbox;
